import { Popover } from 'antd';
import { ExternalLink, IconProps } from 'react-feather';
import { Link } from 'react-router-dom';
import ActionIcon from '../ActionIcon';

interface Props {
  redirect?: string;
  iconProps?: IconProps;
  onClick?: VoidFunction;
  disabled?: boolean;
}

export default function ExternalLinkIcon({
  redirect,
  iconProps,
  onClick,
  disabled,
}: Props) {
  const icon = (
    <ActionIcon disabled={disabled} onClick={onClick}>
      <ExternalLink size={20} cursor={'pointer'} {...iconProps} />
    </ActionIcon>
  );

  return (
    <Popover content="Redirecionar">
      {redirect ? (
        <Link
          to={redirect}
          style={{ pointerEvents: disabled ? 'none' : undefined }}
        >
          {icon}
        </Link>
      ) : (
        icon
      )}
    </Popover>
  );
}
